/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { signInPath } from 'constants/urls';
import { PrimaryButton } from 'ui';
import s from './styles.module.scss';
import Icon from 'components/core/icon';
import HeaderShared from './layout/header';
import SubTitleShared from './layout/subtitle';

const ContactUsSuccess = ({ className = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={cx(s.sharedForm, className)}>
      <HeaderShared>
        <Icon className={s.sharedFormLogo} icon={Icon.icons.logo} />
      </HeaderShared>
      <SubTitleShared>{t('message_was_send')}</SubTitleShared>
      <PrimaryButton className={s.sharedFormSubmit} onClick={() => navigate(signInPath)}>
        {t('go_to_login')}
      </PrimaryButton>
    </div>
  );
};

ContactUsSuccess.propTypes = {
  className: PropTypes.string,
};

export default ContactUsSuccess;
